import { EXTENSIONS, MAX_FILE_SIZE } from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import { DICTIONARY } from "../../dictionary";

const { getRandomUuid } = helpers.utilities;
const { MAX_SIZE, EXTENSION } = DICTIONARY.ERRORS;
const EMPTY_ERROR = "";

export const getAttachedFile = (file: File, index: number) => {
  const { size, name } = file;
  const extension = name.split(".").pop() || "";
  const id = getRandomUuid(`file_id_${index}`);

  const attachedFile = {
    id,
    error: EMPTY_ERROR,
    file,
  };

  if (size > MAX_FILE_SIZE) {
    return { ...attachedFile, error: MAX_SIZE };
  }

  if (!EXTENSIONS.includes(extension.toLowerCase())) {
    return { ...attachedFile, error: EXTENSION };
  }

  return attachedFile;
};
